import { gql } from '@apollo/client'

import {
  DISH_CHOICE_INGREDIENT_FRAGMENT,
  DISH_MAIN_INGREDIENT_FRAGMENT,
} from '../fragments'

const UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED_MUTATION = gql`
  mutation updateDishIngredientDiscrepancyAcceptedMutation(
    $ingredientId: ID!
    $ingredientType: String!
    $dishId: ID!
    $value: Boolean!
  ) {
    updateDishIngredientDiscrepancyAccepted(
      ingredientId: $ingredientId
      ingredientType: $ingredientType
      dishId: $dishId
      value: $value
    ) {
      id
      mainIngredients {
        ...DishMainIngredientFragment
      }
      choiceIngredients {
        ...DishChoiceIngredientFragment
      }
    }
  }
  ${DISH_CHOICE_INGREDIENT_FRAGMENT}
  ${DISH_MAIN_INGREDIENT_FRAGMENT}
`

export default UPDATE_DISH_INGREDIENT_DISCREPANCY_ACCEPTED_MUTATION
